export enum DataType {
    EnterExitHourly,
    EnterExitDaily,
    VisitorsDaily,
}

